import { toggleSceneObject } from "../../togglers";
import { DRAG_STEPS, Y_MAP_YASHCHIKS } from "./pos_map";

export const changeYashchik = ({ count, size = "small" }) => {
    const wardrobeName = servObj.tempName;
    const wardrobeType = servObj.redactorModeObject.userData.loadData.wardrobeType;

    const position = { y: Y_MAP_YASHCHIKS[wardrobeType][size][count] };
    const dragStep = DRAG_STEPS[wardrobeName];

    const allObjects = size === "small" ? servObj.allYashchikWardrobe : servObj.allYashchikWardrobeBig;
    const activeArray = size === "small" ? servObj.activeYashchikWardrobe : servObj.activeYashchikWardrobeBig;

    const nameMap = {
        small: `yashchik__shkaf__shio__2000x1020x620__${count}`,
        big: `yashchik_bolshoy__shkaf__shio__2000x1020x620__${count}`,
    };

    const name = nameMap[size];

    if (wardrobeType === "ship") console.trace("changeYashchik", { count, size });

    toggleSceneObject({
        allObjects,
        activeArray,
        name,
        isChecked: true,
        filterActiveFn: (el) => {
            return el.userData.count < count;
        },
        position,
        userData: { name, count, verticalOnly: true, dragStep, size },
        isStrictName: true,
    });
};
